/**
 * Created by lu on 2017/9/28.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view: {
        'class': ['input', nb.bind('status')],// nb.bind('inputSize'), nb.bind('inputBorder'),nb.bind('status')
        tag: 'input',
        name: nb.bind('name'),//只有设置了 name 属性的表单元素才能在提交表单时传递它们的值。
        type: nb.bind('type'),//规定 input 元素的类型。
        value: nb.bind('value', {
            event: 'change'
        }),//	规定 input 元素的值。inputDisabled
        disabled: nb.bind('inputDisabled'),
        onkeyup: nb.bind('onkeyup'),
        placeholder: nb.bind('placeholder'),//	规定帮助用户填写输入字段的提示。
        readonly: nb.bind('readonly'),    //	规定输入字段为只读
        checked: nb.bind('checked'),
        maxlength: nb.bind('maxlength')  //	规定输入字段中的字符的最大长度。
    },
    method: {
        onModelReady: function (inModel) {
            // inModel.set('value', '');

            inModel.onChange('value', function (inEvent) {//监听input中的值
                inModel.set('status', '');
                inModel.set('errorMsg', '');
            }, this);

            inModel.onChange('focus', function (inEvent) {
                this.$().focus();
            }, this);

            this.$().on('blur', function () {
                inModel.set('blur', true, {skipSameValue: false})
            });

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/form/Input.js
// module id = 46
// module chunks = 0 1 2 3 4 6 9 10 11 12 13 17 18 21 32 35